import React, { Component } from 'react';
import { Route, BrowserRouter as Router, useLocation } from 'react-router-dom';
import smoothScroll from 'smoothscroll';
import './App.css';
import { PreApp } from './PreApp';
import Artist from './artist/Artist';
import Artists from './main/Artists';
import Contact from './main/Contact';
import Footer from './objs/Footer';
import Header from './objs/Header';
import './static/bootstrap/css/bootstrap.min.css';
import './static/style.css';

export const useQuery = () => {
  const query = new URLSearchParams(useLocation().search);
  const type = query.get('type');
  const location = useLocation();
  // const history = useHistory(); // const navigate = useNavigate(); for v6
  // useEffect(() => {
  //   const queryParams = new URLSearchParams(location.search);
  //   const type = queryParams.get('type');

  // if (!['management', 'booking'].includes(type)) {
  //   // If 'type' query parameter is not set, redirect or modify the URL
  //   queryParams.set('type', 'booking');
  //   history.replace({ search: queryParams.toString() });
  //   // navigate(`?${queryParams.toString()}`); for v6
  // }
  // }, [location, history, type]); // [location, navigate] for v6
  return { type, location };
};

const Front = ({ hide }) => {
  const { type } = useQuery();
  return (
    <div style={{ display: hide }}>
      <Artists type={type || 'booking'} />
      <Contact type={type || 'booking'} />
    </div>
  );
};

const App = () => (
  <Router>
    <AppOuter />
  </Router>
);
// return type === null ? <PreApp /> : <InnerApp />;

const AppOuter = () => {
  const { type } = useQuery();

  return type === null ? <PreApp /> : <InnerApp />;
};

class InnerApp extends Component {
  constructor(props) {
    super(props);
    this.state = { hide: null };
    this.update = this.update.bind(this);
    this.menuClick = this.menuClick.bind(this);
  }
  update(path) {
    if (path !== '') {
      this.setState({ hide: 'none' });
    } else {
      this.setState({ hide: null });
    }
  }
  menuClick() {
    this.setState({ hide: null });
  }
  scroll(menu) {
    var w = window;
    var d = document;
    var e = d.documentElement;
    var g = d.getElementsByTagName('body')[0];
    var x = w.innerWidth || e.clientWidth || g.clientWidth;
    var offset = 100;
    if (x < 768) {
      offset = 160;
    }
    var dest = document.querySelector('.' + menu);
    var rect = dest.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var data = { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    var toTop = data.top - offset;
    smoothScroll(toTop);
  }

  render() {
    return (
      <div className="App">
        <Route
          render={(props) => (
            <Header
              {...props}
              menuClick={this.menuClick}
              scroll={this.scroll}
            />
          )}
        />

        <div className="maincontent">
          <Front hide={this.state.hide} />
          <Route
            path="/book/:name"
            render={(props) => (
              <Artist
                {...props}
                update={this.update}
                menuClick={this.menuClick}
              />
            )}
          />
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js